module.exports = __webpack_public_path__ + "static/media/congrate.1f79950b.webp";